import axios, { type AxiosError, type AxiosResponse } from 'axios'
import { GET_API_URL, GOOGLE_RECAPTCHA_ENABLE } from 'shared/config'
import {
  interceptorsRequestError,
  interceptorsRequestSuccess,
} from 'entities/Auth/lib/interceptorsRequest'
import {
  interceptorsApiError,
  interceptorsResponseError,
  interceptorsResponseLogError,
  interceptorsResponseSuccess,
} from 'entities/Auth/lib/interceptorsResponse'
import { getAssumeToken } from 'entities/Auth/lib/setToken'

export const baseApi = axios.create({
  baseURL: GET_API_URL(),
  headers: {
    'Content-type': 'application/json',
    'Salesmsg-App': 'react',
  },
})

const handleInterceptorsResponseSuccess = (config: AxiosResponse): AxiosResponse => {
  const isAssume = Boolean(getAssumeToken())

  return interceptorsResponseSuccess(config, isAssume)
}

export const interceptorsResponseReCaptchaError = async (
  error: AxiosError<{ message: string }>
) => {
  if (!GOOGLE_RECAPTCHA_ENABLE) return Promise.reject(error)

  const isVisualChallengeNeeded = error.response?.data?.message === 'visual_challenge_needed'
  const config = error.config

  if (config && isVisualChallengeNeeded) {
    if (config.reCaptchaStore?.reCaptchaV2Store.error) {
      return Promise.reject(new Error(config.reCaptchaStore?.reCaptchaV2Store.error))
    }

    if (config.reCaptchaStore?.visualChallengeToken) return Promise.reject(error)

    await config.reCaptchaStore?.setVisualChallenge()

    try {
      config.data = {
        ...JSON.parse(config.data),
        ...config.reCaptchaStore?.params,
      }

      return baseApi.request(config)
    } catch (e) {
      return Promise.reject(e)
    }
  }

  return Promise.reject(error)
}

baseApi.interceptors.response.use(null, interceptorsApiError)
baseApi.interceptors.request.use(interceptorsRequestSuccess, interceptorsRequestError)
baseApi.interceptors.response.use(null, interceptorsResponseLogError)
baseApi.interceptors.response.use(null, interceptorsResponseReCaptchaError)
baseApi.interceptors.response.use(handleInterceptorsResponseSuccess, interceptorsResponseError)
